import { createSlice } from "@reduxjs/toolkit";
import MENU_UI_ACTIONS from "../data/MenuUiActionConstants.js";
const loadingStateSlice = createSlice({
  name: 'Loading',
  initialState: {
    isLoading: false
  },
  reducers: {
    changeLoadingState: (state, action) => {
      const { isLoading } = action.payload;
      state.isLoading = isLoading;
    }
  }
});

export const { changeLoadingState } = loadingStateSlice.actions;

export default loadingStateSlice.reducer;

export const currentLoadingState = (state) => state.loadingState.isLoading
